export default __webpack_public_path__ + "static/media/parisSaintGermain.755b4db1.svg";